import { createApi } from '@obv/api-client';

type Listener = () => void;
const unauthListeners: Listener[] = [];

export const APP_VERSION = __APP_VERSION__;

export const api = createApi({
  appVersion: APP_VERSION,
  onUnauthenticated: () => unauthListeners.forEach((l) => l()),
  // A web app "upgrades" by reloading to fetch the new bundle.
  onUpgradeRequired: () => window.location.reload(),
});

/** Tells every listener the session is gone (e.g. the display just unpaired itself). */
export function signalUnauthenticated(): void {
  unauthListeners.forEach((l) => l());
}

export function onUnauthenticated(l: Listener): () => void {
  unauthListeners.push(l);
  return () => {
    const i = unauthListeners.indexOf(l);
    if (i >= 0) unauthListeners.splice(i, 1);
  };
}
